import React, { useEffect, useState } from 'react'
import List from '../../components/List'
import { notificationError } from '../../services/notification'
import { useLoading } from '../../context/LoadingProvider/useLoading'
import { changeDefaultServerById, changeServerStatus, deleteServerById, getDistributorServers } from '../../services/distributors'
import { getNextServerStatusValue, statusOptions } from '../../utils/status'
import { Breadcrumb, Modal, Tag } from 'antd'
import Button from '../../components/UI/Button'
import { useAuth } from '../../context/AuthProvider/useAuth'
import { DeleteOutlined, EditOutlined, HomeOutlined } from '@ant-design/icons'
import { useNavigate, useParams } from 'react-router-dom'
import Head from '../../components/Head'

function index() {
  const {id, name} = useParams()
  const loading = useLoading()
  const {canEdit} = useAuth()
  const history = useNavigate()
  const [serverList, setServerList] = useState<any[]>([])
  const [serverToDelete, setServerToDelete] = useState({
    id: '',
    distributorId: '',
  })
  const [deleteModalVisible, setDeleteModalVisible] = useState(false)
  const [serverToBeDefault, setServerToBeDefault] = useState({
    id: '',
    distributorId: '',
  })
  const [defaultServerModal, setDefaultServerModal] = useState(false)
  
  useEffect(() => {
    if(!id) return 
    getServers(id)
  },[])

  const changeDefaultServer = async () => {
    if (!serverToBeDefault) {
      setDeleteModalVisible(false)
      notificationError('Could not find server info')
    }
    loading.addLoading()
    await changeDefaultServerById({
      distributorId: serverToBeDefault.distributorId,
      serverId: serverToBeDefault.id
    })
    const response = await getDistributorServers({ id: serverToBeDefault.distributorId })
    setServerList(response.list)
    setDefaultServerModal(false)
    loading.removeLoading()

  }
  
  const deleteServer = async () => {
    if (!serverToDelete) return setDeleteModalVisible(false)
    loading.addLoading()
    await deleteServerById(serverToDelete)
    const response = await getDistributorServers({ id: serverToDelete.distributorId })
    setServerList(response.list)
    setDeleteModalVisible(false)
    loading.removeLoading()
  }
  
  const confirmModal = (server: any) => {
    Modal.confirm({
      title: 'Deactivate this server?',
      content: 'This will migrate all locations hadled by it to default server.',
      centered: true,
      onOk: () => onServerChange(server),
      cancelText: 'Close',
    });
  }


  const onServerStatusChange = (server: any) => {
    if (!server) return
    if(getNextServerStatusValue(server.status, 'status') === statusOptions.inactive) {
      return confirmModal(server)
    }
    onServerChange(server)
  }

  const getServers = async (id: string) => {
    if (!id) return notificationError('Can not find the specified distributor')
    loading.addLoading()
    const response = await getDistributorServers({ id })
    setServerList(response.list)
    loading.removeLoading()
  }

  const onServerChange = async (server: any) => {
    loading.addLoading()
    await changeServerStatus({
      id: server.id,
      status: getNextServerStatusValue(server.status, 'status')
    })
    const response = await getDistributorServers({ id: server.distributorId })
    loading.removeLoading()
    if (!response || !response.list) return
    setServerList(response.list)
  }

  const getModalButtonActions = (server: any) => {
    return (
      <div className='distributors__action-buttons'>
        <Button
          disabled={!canEdit}
          onClick={() => onServerStatusChange(server)}
          type='primary'
          style={{
            backgroundColor: getNextServerStatusValue(server.status, 'color'),
            minWidth: '100px',
          }}
        >
          <p>{getNextServerStatusValue(server.status, 'label')}</p>
        </Button>
        <Button
          disabled={!canEdit}
          onClick={() => history(`/distributorserver/new/${server.distributorId}/${server.id}`)}
          type='primary'
          style={{ backgroundColor: '#2fa4e7' }}
        >
          <EditOutlined style={{ fontSize: '16px', color: '#FFF' }} />
        </Button>
        <Button
          disabled={!canEdit}
          onClick={() => {
            setServerToDelete({ id: server.id, distributorId: server.distributorId })
            setDeleteModalVisible(true)
          }}
          type='primary'
          style={{ backgroundColor: '#d41d24' }}
        >
          <DeleteOutlined style={{ fontSize: '16px', color: '#FFF' }} />
        </Button>
        {server.defaultServer === 'false' && (
          <Button
            disabled={!canEdit}
            onClick={() => {
              setServerToBeDefault({ id: server.id, distributorId: server.distributorId })
              setDefaultServerModal(true)
            }}
            type='primary'
            style={{ minWidth: '120px' }}
          >
            <p>Set as Default</p>
          </Button>
        )}
      </div>
    )
  }

  const items = [
    {
      title:<a onClick={() => history('/welcome')} href='#'><HomeOutlined style={{fontSize: 18}} /></a>
    },
    {
      title: <a onClick={() => history('/distributors')} href='#'>Distributors</a>
    },
    {
      title:<a href='#'>{name && 'Server ' + name.replaceAll('%20', ' ')}</a>
    },
  ];

  function itemRender(route: any, params: any, items: any, paths: any) {
    const item = items.indexOf(route);
    if(item == 0) {
      return <span>{route.title}</span>
    } else if(item === 1) {
      return <span style={{color: 'rgba(0, 0, 0, 0.45)'}}>{route.title}</span>
    } else if (item === 2) {
      return <span>{route.title}</span>
    }
  }

return (
  <div>
    <Modal title="Are you sure you want to delete the server?" open={deleteModalVisible} onCancel={() => setDeleteModalVisible(false)} onOk={() => deleteServer()} />
    <Modal title="Are you sure you want to make it the default server?" open={defaultServerModal} onCancel={() => setDefaultServerModal(false)} onOk={() => changeDefaultServer()} />
    <Head title="All Distributors" buttonText='New Server' buttonAction={() => history(`/distributorserver/new/${id}/`)} disabled={!canEdit}/>
    <div className="advanced-breadcrumb">
      <Breadcrumb itemRender={itemRender} items={items} />
    </div>
      <List
        rows={serverList || []}
        style={{marginBottom: 0, boxShadow:'none'}}
        columns={[
          {
            title: 'Alias',
            dataIndex: 'serverAlias',
            key: 'serverAlias',
            render: (value: string) => value,
            width: 100
          },
          {
            title: 'Public Address',
            dataIndex: 'serverAddress',
            key: 'serverAddress',
            render: (value: string) => value,
            width: 130
          },
          {
            title: 'Private Adress',
            dataIndex: 'serverAddressPrivate',
            key: 'serverAddressPrivate',
            render: (value: string) => value,
            width: 100
          },
          {
            title: 'Default Server',
            dataIndex: 'defaultServer',
            key: 'defaultServer',
            render: (value: string) => <Tag color={value === 'true' ? 'green' : 'red'}> {value} </Tag>,
            width: 90
          },
          {
            title: 'Active Locations',
            dataIndex: 'activeLocations',
            key: 'activeLocations',
            render: (value: string) => value,
            width: 100
          },
          {
            title: '',
            dataIndex: '',
            key: '',
            render: (value: any) => getModalButtonActions(value),
            width: 350
          },
        ]}
      />
    </div>
  )
}

export default index